document.addEventListener('DOMContentLoaded', function() {
  const entireSection = document.querySelector('.our-process-wrapper');
  
  if (!entireSection) return;

  entireSection.addEventListener('click', displaySecondContent);

  function displaySecondContent(event) {
    const firstDesktopContent = document.querySelector('.desktop-content .first-content');
    const secondDesktopContent = document.querySelector('.desktop-content .second-content');
    const firstMobileContent = document.querySelector('.mobile-content .first-content');
    const secondMobileContent = document.querySelector('.mobile-content .second-content');
    const firstDesktopImage = document.querySelector('.desktop-image .first-image');
    const secondDesktopImage = document.querySelector('.desktop-image .second-image');
    const firstMobileImage = document.querySelector('.mobile-image .first-image');
    const secondMobileImage = document.querySelector('.mobile-image .second-image');

    // Return if any element is missing
    if (!firstDesktopContent || !secondDesktopContent || !firstMobileContent || !secondMobileContent ||
        !firstDesktopImage || !secondDesktopImage || !firstMobileImage || !secondMobileImage) {
      return;
    }

    firstDesktopContent.style.display = 'none';
    firstMobileContent.style.display = 'none';
    firstDesktopImage.style.display = 'none';
    firstMobileImage.style.display = 'none';

    if (window.innerWidth >= 375) {
      secondDesktopContent.style.display = 'block';
      secondDesktopImage.style.display = 'block';
      secondMobileContent.style.display = 'none';
      secondMobileImage.style.display = 'none';
    } else {
      secondMobileContent.style.display = 'block';
      secondDesktopImage.style.display = 'none';
      secondMobileImage.style.display = 'block';
      secondDesktopContent.style.display = 'none';
      
    }
  }
});